var map = {
	"./Ambidextr.png": 174,
	"./BACKBASE.png": 175,
	"./Coinsdataflow.jpeg": 176,
	"./Cointelegraph.jpeg": 177,
	"./EY.jpeg": 178,
	"./FinancialIT.jpeg": 179,
	"./Kitamo.png": 180,
	"./NIIT.jpeg": 181,
	"./Neosoft.jpeg": 182,
	"./NewsAffinity.jpeg": 183,
	"./NewsAffinity.png": 184,
	"./PaymentsAfrika.png": 185,
	"./Payoneer.jpeg": 186,
	"./Sinofy Logo .png": 187,
	"./TEMENOS.png": 188,
	"./TP.png": 189,
	"./Vaccumlabs.jpg": 190,
	"./Watermelon.jpeg": 191,
	"./abaka.jpg": 192,
	"./accurascan.png": 193,
	"./africa.jpeg": 194,
	"./ambidextr.jpeg": 195,
	"./amm.png": 196,
	"./antariksh.png": 197,
	"./arabnet.jpeg": 198,
	"./aroundb.png": 199,
	"./assertify.png": 200,
	"./authlete.png": 201,
	"./avaya.png": 202,
	"./azentio.png": 203,
	"./baa.png": 204,
	"./backbase.jpeg": 205,
	"./bankingcio.jpeg": 206,
	"./bankserv.jpg": 207,
	"./bankserv.png": 208,
	"./bankservAfrica.png": 209,
	"./bc.jpeg": 210,
	"./beingcrypto.jpg": 211,
	"./beingcrypto.png": 212,
	"./bigdata.jpeg": 213,
	"./blocksocial.jpeg": 214,
	"./blocksocial.png": 215,
	"./caia.jpeg": 216,
	"./cbon.png": 217,
	"./cexio.jpg": 218,
	"./cibe.jpeg": 219,
	"./cio.png": 220,
	"./coforge.jpg": 221,
	"./cognerium.png": 222,
	"./coinquora.png": 223,
	"./coinrepublic.png": 224,
	"./coinsflare.jpeg": 225,
	"./coinsflare.png": 226,
	"./comarch.jpeg": 227,
	"./comforte.png": 228,
	"./comviva.png": 229,
	"./concerto.png": 230,
	"./consdata.jpeg": 231,
	"./consdata.png": 232,
	"./cryptonewz.jpeg": 233,
	"./da.png": 234,
	"./daon.jpg": 235,
	"./daon.png": 236,
	"./difc.jpg": 237,
	"./ecsFin.png": 238,
	"./edb.png": 239,
	"./elev8.png": 240,
	"./eppan.png": 241,
	"./expo.jpeg": 242,
	"./expo2020.png": 243,
	"./findbiometrics.jpeg": 244,
	"./fintech.jpeg": 245,
	"./fintechfinance.jpeg": 246,
	"./fintechfutures.jpeg": 247,
	"./fintechgalaxy.jpeg": 248,
	"./fintechna.jpg": 249,
	"./fintechna.png": 250,
	"./fintechnetwork.png": 251,
	"./fintechpower.jpeg": 252,
	"./fintechtimes.jpeg": 253,
	"./freshworks.png": 254,
	"./fss.png": 255,
	"./genesys.png": 256,
	"./hcl.jpg": 257,
	"./hilton.png": 258,
	"./hyperpay.jpeg": 259,
	"./ibm.jpeg": 260,
	"./ie.jpg": 261,
	"./iib.jpeg": 262,
	"./infobip.jpeg": 263,
	"./infosys.jpg": 264,
	"./infrasoft.png": 265,
	"./investera.jpeg": 266,
	"./isaca.png": 267,
	"./kigali.png": 268,
	"./kissflow.jpg": 269,
	"./kitamo.jpeg": 270,
	"./knoxwire.jpg": 271,
	"./maxut.png": 272,
	"./menafintech.jpeg": 273,
	"./microsoft.png": 274,
	"./mobileidworld.jpeg": 275,
	"./moengage.png": 276,
	"./neosoft.png": 277,
	"./netcore.png": 278,
	"./network.jpg": 279,
	"./newgen.png": 280,
	"./onespan.jpeg": 281,
	"./onespan.jpg": 282,
	"./onespan.png": 283,
	"./openfactor.png": 284,
	"./oracle.jpeg": 285,
	"./oracle.jpg": 286,
	"./oracle.png": 287,
	"./oxford.png": 288,
	"./oz.png": 289,
	"./paypers.jpg": 290,
	"./piotech.png": 291,
	"./privatebanking.jpeg": 292,
	"./pursoft.png": 293,
	"./pwc.jpeg": 294,
	"./pwc.jpg": 295,
	"./qifc.png": 296,
	"./regtech.png": 297,
	"./rubrik.jpg": 298,
	"./scventure.jpg": 299,
	"./sinofy.png": 300,
	"./smartstream.jpeg": 301,
	"./smartstream.png": 302,
	"./sybrin.png": 303,
	"./tata.jpeg": 304,
	"./tcs.jpg": 305,
	"./technotree.png": 306,
	"./telco.jpeg": 307,
	"./temenos.jpg": 308,
	"./threatLocker.jpg": 309,
	"./tracefinancial.png": 310,
	"./tracefinancialblue 700x250.png": 311,
	"./tripwire.jpeg": 312,
	"./truebanking.jpeg": 313,
	"./turbonomic.png": 314,
	"./veripark.png": 315,
	"./visa.jpg": 316,
	"./visa.png": 317,
	"./vismaya.png": 318,
	"./worldpay.jpg": 319,
	"./worldpay.png": 320,
	"./yellow.png": 321,
	"./yethi.png": 322,
	"./zentity.png": 323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 53;